import { Share as CapacitorShare } from '@capacitor/share';
import { withOperatorExternalActivity } from '../../auth/operatorExternalActivity.js';

export const Share = {
  share(options: Parameters<typeof CapacitorShare.share>[0]) {
    return withOperatorExternalActivity(() => CapacitorShare.share(options));
  },
};

export function shareWithNavigator(data: ShareData): Promise<void> {
  if (typeof navigator.share !== 'function') {
    return Promise.reject(new Error('web_share_unavailable'));
  }
  return withOperatorExternalActivity(() => navigator.share(data));
}
